import { z } from "zod";

/**
 * The caller's answers to a screening mammogram's screening questions: reported facts, not clinical history or a
 * policy override. Omitted means the question wasn't asked; false and true are explicit answers.
 */
export const callerReportedMammogramScreenSchema = z.strictObject({
  /** A new breast lump, breast pain, nipple thickening or discharge, or a change in breast size or shape. */
  breastSymptoms: z.boolean().optional(),
  /** A follow-up, callback or recheck after an earlier mammogram, or a diagnostic one a provider asked for. */
  followUpImaging: z.boolean().optional(),
  /** Breast implants, or a wheelchair at the visit. */
  implantsOrWheelchair: z.boolean().optional(),
});
export type CallerReportedMammogramScreen = z.infer<typeof callerReportedMammogramScreenSchema>;
